import { MONTHS } from './constants'

export function errorHandler(error: unknown): void {
  console.error(error)
}

export function getCookie(key: string): string {
  const b = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`)
  return b ? b.pop() || '' : ''
}

export function deleteCookie(key: string): void {
  // eslint-disable-next-line no-restricted-globals
  document.cookie = `${key}=; Max-Age=0; path=/; domain=${location.hostname}`
}

export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

export function convertTimestamp(timestamp: number) {
  const date = new Date(timestamp * 1000)
  return `${MONTHS[date.getMonth()]} ${date.getDate()}`
}
